var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-drawer",
        {
          attrs: {
            visible: _vm.drawer,
            "custom-class": "drawer-wrap-detail",
            direction: "rtl",
            "before-close": _vm.closeDrawer,
          },
          on: {
            "update:visible": function ($event) {
              _vm.drawer = $event
            },
          },
        },
        [
          _vm.drawer
            ? [
                _c("div", { staticClass: "drawer_header" }, [
                  _c(
                    "div",
                    [
                      _vm.form.companyName && _vm.form.companyName.length > 20
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.form.companyName,
                                placement: "top",
                              },
                            },
                            [
                              _c("b", [
                                _vm._v(
                                  _vm._s(
                                    _vm.getCompanyName(_vm.form.companyName)
                                  )
                                ),
                              ]),
                            ]
                          )
                        : _c("b", [
                            _vm._v(
                              _vm._s(_vm.getCompanyName(_vm.form.companyName))
                            ),
                          ]),
                      _vm.form.name && _vm.form.name.length > 10
                        ? _c(
                            "el-tooltip",
                            {
                              staticClass: "item",
                              attrs: {
                                effect: "dark",
                                content: _vm.form.name,
                                placement: "top",
                              },
                            },
                            [
                              _c("span", [
                                _vm._v(_vm._s(_vm.getName(_vm.form.name))),
                              ]),
                            ]
                          )
                        : _c("span", [
                            _vm._v(_vm._s(_vm.getName(_vm.form.name))),
                          ]),
                      _vm.CallPermissionBtn("90001")
                        ? _c("img", {
                            staticStyle: { cursor: "pointer" },
                            attrs: {
                              src: require("@/assets/call/phone-icon.png"),
                              alt: "",
                            },
                            on: { click: _vm.handleClickCall },
                          })
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "div",
                    [
                      _vm.form.leadState !== 5 &&
                      _vm.form.leadState !== 0 &&
                      _vm.form.leadState !== 4
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.clickFollow },
                            },
                            [_vm._v("添加跟进")]
                          )
                        : _vm._e(),
                      _vm.form.leadState !== 5 && _vm.detailType
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.clickAllot },
                            },
                            [_vm._v("分配名单")]
                          )
                        : _vm._e(),
                      _vm.form.leadState === 4
                        ? _c(
                            "el-button",
                            {
                              attrs: { size: "small", type: "primary" },
                              on: { click: _vm.clickActivate },
                            },
                            [_vm._v("激活名单")]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _c(
                    "p",
                    [
                      _c("span", [_vm._v("名单状态")]),
                      _vm.form.leadState === 0
                        ? _c("play-status", { attrs: { type: "violet" } }, [
                            _vm._v("待分配"),
                          ])
                        : _vm._e(),
                      _vm.form.leadState === 1
                        ? _c("play-status", { attrs: { type: "primary" } }, [
                            _vm._v("待联系"),
                          ])
                        : _vm._e(),
                      _vm.form.leadState === 2
                        ? _c("play-status", { attrs: { type: "error" } }, [
                            _vm._v("未接通"),
                          ])
                        : _vm._e(),
                      _vm.form.leadState === 3
                        ? _c("play-status", { attrs: { type: "warning" } }, [
                            _vm._v("待定"),
                          ])
                        : _vm._e(),
                      _vm.form.leadState === 4
                        ? _c("play-status", { attrs: { type: "disabled" } }, [
                            _vm._v("已关闭"),
                          ])
                        : _vm._e(),
                      _vm.form.leadState === 5
                        ? _c("play-status", { attrs: { type: "green" } }, [
                            _vm._v("已转线索"),
                          ])
                        : _vm._e(),
                      _vm.rowData.leadState !== 0
                        ? _c("span", [_vm._v("归属人")])
                        : _vm._e(),
                      _vm.rowData.leadState !== 0
                        ? _c("em", [_vm._v(_vm._s(_vm.form.ownerName || "--"))])
                        : _vm._e(),
                    ],
                    1
                  ),
                ]),
                _c(
                  "div",
                  { staticClass: "drawer_body" },
                  [
                    _c(
                      "el-tabs",
                      {
                        on: { "tab-click": _vm.handleClick },
                        model: {
                          value: _vm.activeName,
                          callback: function ($$v) {
                            _vm.activeName = $$v
                          },
                          expression: "activeName",
                        },
                      },
                      [
                        _c(
                          "el-tab-pane",
                          { attrs: { label: "名单详情", name: "first" } },
                          [
                            _c(
                              "el-form",
                              {
                                ref: "form",
                                attrs: {
                                  model: _vm.form,
                                  "label-width": "100px",
                                },
                              },
                              [
                                _c(
                                  "div",
                                  { staticClass: "drawer_content" },
                                  [
                                    _c("h2", [_vm._v("基本信息")]),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "公司名称" } },
                                              [
                                                _vm.editKey === "companyName"
                                                  ? _c("el-input", {
                                                      ref: "companyName",
                                                      attrs: {
                                                        maxlength: "50",
                                                        placeholder:
                                                          "请输入公司名称",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.companyName,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "companyName",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.companyName",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.companyName
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form
                                                                    .companyName,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .companyName
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "companyName"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人姓名" },
                                              },
                                              [
                                                _vm.editKey === "name"
                                                  ? _c("el-input", {
                                                      ref: "name",
                                                      attrs: {
                                                        maxlength: "20",
                                                        placeholder:
                                                          "请输入联系人姓名",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value: _vm.form.name,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "name",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression: "form.name",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.name
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form.name,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .name
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "name"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "公司所在区域",
                                                },
                                              },
                                              [
                                                _c("el-cascader", {
                                                  ref: "cascader",
                                                  attrs: {
                                                    size: "small",
                                                    filterable: "",
                                                    props: {
                                                      checkStrictly: true,
                                                    },
                                                    options: _vm.areaData,
                                                    clearable: "",
                                                    placeholder:
                                                      "请选择公司所在区域",
                                                  },
                                                  on: {
                                                    change: _vm.changeForm,
                                                  },
                                                  model: {
                                                    value:
                                                      _vm.form.companyRegion,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "companyRegion",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "form.companyRegion",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人手机" },
                                              },
                                              [
                                                _vm.editKey === "mobilePhone"
                                                  ? _c("el-input", {
                                                      ref: "mobilePhone",
                                                      attrs: {
                                                        maxlength: "11",
                                                        placeholder:
                                                          "请输入联系人手机",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                        input: function (
                                                          $event
                                                        ) {
                                                          _vm.form.mobilePhone =
                                                            _vm.form.mobilePhone.replace(
                                                              /[^\d]/g,
                                                              ""
                                                            )
                                                        },
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.mobilePhone,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "mobilePhone",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.mobilePhone",
                                                      },
                                                    })
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-edit",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.form
                                                                .mobilePhone ||
                                                                "--"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "mobilePhone"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "公司地址" } },
                                              [
                                                _vm.editKey === "address"
                                                  ? _c("el-input", {
                                                      ref: "address",
                                                      attrs: {
                                                        maxlength: "100",
                                                        placeholder:
                                                          "请输入公司地址",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value: _vm.form.address,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "address",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.address",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.address
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form
                                                                    .address,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .address
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "address"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "手机归属地" },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.provinceCity ||
                                                          "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "团队规模" } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请选择团队规模",
                                                      clearable: "",
                                                    },
                                                    on: {
                                                      change: _vm.changeForm,
                                                    },
                                                    model: {
                                                      value: _vm.form.teamSize,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "teamSize",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.teamSize",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.employeeCountList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label: item.title,
                                                          value: item.id,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "自动定位城市",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.location ||
                                                          "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "所属行业" } },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请选择所属行业",
                                                    },
                                                    on: {
                                                      change: _vm.changeForm,
                                                    },
                                                    model: {
                                                      value: _vm.form.industry,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "industry",
                                                          $$v
                                                        )
                                                      },
                                                      expression:
                                                        "form.industry",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.industryList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label: item.title,
                                                          value: item.id,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "来源渠道" } },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.clueSource ||
                                                          "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _vm._l(
                                          _vm.form.remarkDict,
                                          function (item, key, index) {
                                            return _c(
                                              "div",
                                              { key: index },
                                              [
                                                key !== "公司名称"
                                                  ? _c(
                                                      "el-col",
                                                      {
                                                        staticClass: "item-max",
                                                        attrs: { span: 12 },
                                                      },
                                                      [
                                                        _c(
                                                          "el-form-item",
                                                          [
                                                            key.length > 6
                                                              ? _c(
                                                                  "el-tooltip",
                                                                  {
                                                                    staticClass:
                                                                      "item",
                                                                    attrs: {
                                                                      slot: "label",
                                                                      effect:
                                                                        "dark",
                                                                      content:
                                                                        key,
                                                                      placement:
                                                                        "top",
                                                                    },
                                                                    slot: "label",
                                                                  },
                                                                  [
                                                                    _c("span", [
                                                                      _vm._v(
                                                                        _vm._s(
                                                                          key
                                                                        )
                                                                      ),
                                                                    ]),
                                                                  ]
                                                                )
                                                              : _c(
                                                                  "span",
                                                                  {
                                                                    attrs: {
                                                                      slot: "label",
                                                                    },
                                                                    slot: "label",
                                                                  },
                                                                  [
                                                                    _vm._v(
                                                                      _vm._s(
                                                                        key
                                                                      )
                                                                    ),
                                                                  ]
                                                                ),
                                                            _vm.editKey ===
                                                            "demand" + index
                                                              ? _c("el-input", {
                                                                  ref:
                                                                    "demand" +
                                                                    index,
                                                                  refInFor: true,
                                                                  attrs: {
                                                                    placeholder:
                                                                      "请输入客户需求",
                                                                    size: "small",
                                                                  },
                                                                  on: {
                                                                    blur: _vm.changeForm,
                                                                  },
                                                                  model: {
                                                                    value:
                                                                      _vm.form
                                                                        .remarkDict[
                                                                        key
                                                                      ],
                                                                    callback:
                                                                      function (
                                                                        $$v
                                                                      ) {
                                                                        _vm.$set(
                                                                          _vm
                                                                            .form
                                                                            .remarkDict,
                                                                          key,
                                                                          typeof $$v ===
                                                                            "string"
                                                                            ? $$v.trim()
                                                                            : $$v
                                                                        )
                                                                      },
                                                                    expression:
                                                                      "form.remarkDict[key]",
                                                                  },
                                                                })
                                                              : [
                                                                  _vm.form
                                                                    .remarkDict[
                                                                    key
                                                                  ]
                                                                    ? _c(
                                                                        "el-tooltip",
                                                                        {
                                                                          staticClass:
                                                                            "item",
                                                                          attrs:
                                                                            {
                                                                              effect:
                                                                                "dark",
                                                                              content:
                                                                                _vm
                                                                                  .form
                                                                                  .remarkDict[
                                                                                  key
                                                                                ],
                                                                              placement:
                                                                                "top",
                                                                            },
                                                                        },
                                                                        [
                                                                          _c(
                                                                            "span",
                                                                            {
                                                                              staticClass:
                                                                                "span-edit",
                                                                            },
                                                                            [
                                                                              _vm._v(
                                                                                _vm._s(
                                                                                  _vm
                                                                                    .form
                                                                                    .remarkDict[
                                                                                    key
                                                                                  ]
                                                                                )
                                                                              ),
                                                                            ]
                                                                          ),
                                                                        ]
                                                                      )
                                                                    : _c(
                                                                        "span",
                                                                        {
                                                                          staticClass:
                                                                            "span-edit",
                                                                        },
                                                                        [
                                                                          _vm._v(
                                                                            "--"
                                                                          ),
                                                                        ]
                                                                      ),
                                                                  _c("img", {
                                                                    staticClass:
                                                                      "img-edit",
                                                                    attrs: {
                                                                      src: require("@/assets/call/edit.png"),
                                                                      alt: "",
                                                                    },
                                                                    on: {
                                                                      click:
                                                                        function (
                                                                          $event
                                                                        ) {
                                                                          return _vm.clickIsEdit(
                                                                            "demand" +
                                                                              index
                                                                          )
                                                                        },
                                                                    },
                                                                  }),
                                                                ],
                                                          ],
                                                          2
                                                        ),
                                                      ],
                                                      1
                                                    )
                                                  : _vm._e(),
                                              ],
                                              1
                                            )
                                          }
                                        ),
                                      ],
                                      2
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "drawer_content mt-16" },
                                  [
                                    _c("h2", [_vm._v("详细信息")]),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人电话" },
                                              },
                                              [
                                                _vm.editKey === "telephone"
                                                  ? _c("el-input", {
                                                      ref: "telephone",
                                                      attrs: {
                                                        maxlength: "12",
                                                        placeholder:
                                                          "请输入联系人电话",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.telephone,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "telephone",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.telephone",
                                                      },
                                                    })
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-edit",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.form
                                                                .telephone ||
                                                                "--"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "telephone"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人性别" },
                                              },
                                              [
                                                _c(
                                                  "el-radio-group",
                                                  {
                                                    attrs: { size: "small" },
                                                    on: {
                                                      change: _vm.changeForm,
                                                    },
                                                    model: {
                                                      value: _vm.form.gender,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "gender",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.gender",
                                                    },
                                                  },
                                                  [
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 0 } },
                                                      [_vm._v("未知")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 1 } },
                                                      [_vm._v("先生")]
                                                    ),
                                                    _c(
                                                      "el-radio",
                                                      { attrs: { label: 2 } },
                                                      [_vm._v("女士")]
                                                    ),
                                                  ],
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人角色" },
                                              },
                                              [
                                                _c(
                                                  "el-select",
                                                  {
                                                    attrs: {
                                                      size: "small",
                                                      placeholder:
                                                        "请选择联系人角色",
                                                    },
                                                    on: {
                                                      change: _vm.changeForm,
                                                    },
                                                    model: {
                                                      value: _vm.form.role,
                                                      callback: function ($$v) {
                                                        _vm.$set(
                                                          _vm.form,
                                                          "role",
                                                          $$v
                                                        )
                                                      },
                                                      expression: "form.role",
                                                    },
                                                  },
                                                  _vm._l(
                                                    _vm.roleList,
                                                    function (item, index) {
                                                      return _c("el-option", {
                                                        key: index,
                                                        attrs: {
                                                          label: item.title,
                                                          value: item.code,
                                                        },
                                                      })
                                                    }
                                                  ),
                                                  1
                                                ),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人部门" },
                                              },
                                              [
                                                _vm.editKey === "department"
                                                  ? _c("el-input", {
                                                      ref: "department",
                                                      attrs: {
                                                        size: "small",
                                                        maxlength: "20",
                                                        placeholder:
                                                          "请填写联系人部门",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.department,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "department",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.department",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.department
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form
                                                                    .department,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .department
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  _vm.form
                                                                    .department ||
                                                                    "--"
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "department"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人职位" },
                                              },
                                              [
                                                _vm.editKey === "position"
                                                  ? _c("el-input", {
                                                      ref: "position",
                                                      attrs: {
                                                        maxlength: "20",
                                                        placeholder:
                                                          "请输入联系人职位",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value:
                                                          _vm.form.position,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "position",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.position",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.position
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form
                                                                    .position,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .position
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "position"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "联系人微信号",
                                                },
                                              },
                                              [
                                                _vm.editKey === "weixin"
                                                  ? _c("el-input", {
                                                      ref: "weixin",
                                                      attrs: {
                                                        maxlength: "20",
                                                        placeholder:
                                                          "请输入联系人微信号",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value: _vm.form.weixin,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "weixin",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.weixin",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.weixin
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form
                                                                    .weixin,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .weixin
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "weixin"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "联系人QQ" } },
                                              [
                                                _vm.editKey === "qq"
                                                  ? _c("el-input", {
                                                      ref: "qq",
                                                      attrs: {
                                                        maxlength: "20",
                                                        placeholder:
                                                          "请输入联系人QQ",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value: _vm.form.qq,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "qq",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression: "form.qq",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.qq
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form.qq,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .qq
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "qq"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人邮箱" },
                                              },
                                              [
                                                _vm.editKey === "email"
                                                  ? _c("el-input", {
                                                      ref: "email",
                                                      attrs: {
                                                        maxlength: "50",
                                                        placeholder:
                                                          "请输入联系人邮箱",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value: _vm.form.email,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "email",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.email",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.email
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form
                                                                    .email,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .email
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "email"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人年龄" },
                                              },
                                              [
                                                _vm.editKey === "age"
                                                  ? _c("el-input", {
                                                      ref: "age",
                                                      attrs: {
                                                        maxlength: "3",
                                                        placeholder:
                                                          "请输入联系人年龄",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                        input: function (
                                                          $event
                                                        ) {
                                                          _vm.form.age =
                                                            _vm.form.age.replace(
                                                              /[^\d]/g,
                                                              ""
                                                            )
                                                        },
                                                      },
                                                      model: {
                                                        value: _vm.form.age,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "age",
                                                            $$v
                                                          )
                                                        },
                                                        expression: "form.age",
                                                      },
                                                    })
                                                  : [
                                                      _c(
                                                        "span",
                                                        {
                                                          staticClass:
                                                            "span-edit",
                                                        },
                                                        [
                                                          _vm._v(
                                                            _vm._s(
                                                              _vm.form.age ||
                                                                "--"
                                                            )
                                                          ),
                                                        ]
                                                      ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "age"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人备注" },
                                              },
                                              [
                                                _vm.editKey === "remark"
                                                  ? _c("el-input", {
                                                      ref: "remark",
                                                      attrs: {
                                                        maxlength: "1000",
                                                        placeholder:
                                                          "请输入联系人备注",
                                                        size: "small",
                                                      },
                                                      on: {
                                                        blur: _vm.changeForm,
                                                      },
                                                      model: {
                                                        value: _vm.form.remark,
                                                        callback: function (
                                                          $$v
                                                        ) {
                                                          _vm.$set(
                                                            _vm.form,
                                                            "remark",
                                                            typeof $$v ===
                                                              "string"
                                                              ? $$v.trim()
                                                              : $$v
                                                          )
                                                        },
                                                        expression:
                                                          "form.remark",
                                                      },
                                                    })
                                                  : [
                                                      _vm.form.remark
                                                        ? _c(
                                                            "el-tooltip",
                                                            {
                                                              staticClass:
                                                                "item",
                                                              attrs: {
                                                                effect: "dark",
                                                                content:
                                                                  _vm.form
                                                                    .remark,
                                                                placement:
                                                                  "top",
                                                              },
                                                            },
                                                            [
                                                              _c(
                                                                "span",
                                                                {
                                                                  staticClass:
                                                                    "span-edit",
                                                                },
                                                                [
                                                                  _vm._v(
                                                                    _vm._s(
                                                                      _vm.form
                                                                        .remark
                                                                    )
                                                                  ),
                                                                ]
                                                              ),
                                                            ]
                                                          )
                                                        : _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "span-edit",
                                                            },
                                                            [_vm._v("--")]
                                                          ),
                                                      _c("img", {
                                                        staticClass: "img-edit",
                                                        attrs: {
                                                          src: require("@/assets/call/edit.png"),
                                                          alt: "",
                                                        },
                                                        on: {
                                                          click: function (
                                                            $event
                                                          ) {
                                                            return _vm.clickIsEdit(
                                                              "remark"
                                                            )
                                                          },
                                                        },
                                                      }),
                                                    ],
                                              ],
                                              2
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: { label: "联系人生日" },
                                              },
                                              [
                                                _c("el-date-picker", {
                                                  attrs: {
                                                    "picker-options":
                                                      _vm.pickerOptionsTime,
                                                    type: "date",
                                                    size: "small",
                                                    format: "yyyy-MM-dd",
                                                    "value-format":
                                                      "yyyy-MM-dd",
                                                    placeholder:
                                                      "请选择联系人生日",
                                                  },
                                                  on: {
                                                    change: _vm.changeForm,
                                                  },
                                                  model: {
                                                    value: _vm.form.birthday,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        _vm.form,
                                                        "birthday",
                                                        $$v
                                                      )
                                                    },
                                                    expression: "form.birthday",
                                                  },
                                                }),
                                              ],
                                              1
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                                _c(
                                  "div",
                                  { staticClass: "drawer_content mt-16" },
                                  [
                                    _c("h2", [_vm._v("系统信息")]),
                                    _c(
                                      "el-row",
                                      [
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "名单编号" } },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.leadNo || "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "创建日期" } },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.createAt ||
                                                          "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              { attrs: { label: "创建人员" } },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.createByName ||
                                                          "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "最后修改日期",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.updateAt ||
                                                          "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                        _c(
                                          "el-col",
                                          { attrs: { span: 12 } },
                                          [
                                            _c(
                                              "el-form-item",
                                              {
                                                attrs: {
                                                  label: "最后修改人员",
                                                },
                                              },
                                              [
                                                _c(
                                                  "span",
                                                  { staticClass: "span-edit" },
                                                  [
                                                    _vm._v(
                                                      _vm._s(
                                                        _vm.form.updateByName ||
                                                          "--"
                                                      )
                                                    ),
                                                  ]
                                                ),
                                              ]
                                            ),
                                          ],
                                          1
                                        ),
                                      ],
                                      1
                                    ),
                                  ],
                                  1
                                ),
                              ]
                            ),
                          ],
                          1
                        ),
                        _c("el-tab-pane", {
                          attrs: { label: "跟进记录", name: "second" },
                        }),
                        _c("el-tab-pane", {
                          attrs: { label: "通话记录", name: "third" },
                        }),
                      ],
                      1
                    ),
                    _vm.activeName !== "first"
                      ? _c(
                          "div",
                          { staticClass: "drawer_followUp" },
                          [
                            !_vm.dataList.length
                              ? _c("div", { staticClass: "tac mt-20 mb-20" }, [
                                  _vm._v("暂无数据"),
                                ])
                              : _vm._e(),
                            _vm._l(_vm.dataList, function (item, index) {
                              return _c(
                                "div",
                                {
                                  key: _vm.activeName + index,
                                  staticClass: "followUp_list",
                                },
                                [
                                  _c("p", [_vm._v(_vm._s(item.formatTime))]),
                                  _c(
                                    "div",
                                    { staticClass: "followUp_content" },
                                    [
                                      _c(
                                        "el-row",
                                        { staticClass: "followUp_title" },
                                        [
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "tal",
                                              attrs: { span: 18 },
                                            },
                                            [
                                              item.staffInfo &&
                                              item.staffInfo.avatar
                                                ? _c("img", {
                                                    attrs: {
                                                      src: item.staffInfo
                                                        .avatar,
                                                      alt: "",
                                                    },
                                                  })
                                                : _c("img", {
                                                    attrs: {
                                                      src: require("@/assets/navtop_imgs/headportrait.png"),
                                                      alt: "",
                                                    },
                                                  }),
                                              item.staffInfo
                                                ? _c("b", [
                                                    _vm._v(
                                                      _vm._s(
                                                        item.staffInfo.userName
                                                      ) +
                                                        "（" +
                                                        _vm._s(
                                                          item.staffInfo
                                                            .departmentName
                                                        ) +
                                                        "）"
                                                    ),
                                                  ])
                                                : _vm._e(),
                                            ]
                                          ),
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "tar",
                                              attrs: { span: 6 },
                                            },
                                            [
                                              _vm.activeName === "second"
                                                ? [
                                                    item.communicationName
                                                      ? _c("span", [
                                                          _c("i", {
                                                            staticClass:
                                                              "el-icon-location mr-5",
                                                            staticStyle: {
                                                              color: "#999",
                                                            },
                                                          }),
                                                          _c(
                                                            "span",
                                                            {
                                                              staticClass:
                                                                "mr-10",
                                                              staticStyle: {
                                                                color: "#999",
                                                                "font-size":
                                                                  "12px",
                                                              },
                                                            },
                                                            [
                                                              _vm._v(
                                                                _vm._s(
                                                                  item.communicationName
                                                                )
                                                              ),
                                                            ]
                                                          ),
                                                        ])
                                                      : _vm._e(),
                                                    _c(
                                                      "span",
                                                      {
                                                        staticStyle: {
                                                          display:
                                                            "inline-block",
                                                          width: "70px",
                                                        },
                                                      },
                                                      [
                                                        item.changeResult ===
                                                        "未接通"
                                                          ? _c(
                                                              "play-status",
                                                              {
                                                                attrs: {
                                                                  type: "error",
                                                                },
                                                              },
                                                              [_vm._v("未接通")]
                                                            )
                                                          : _vm._e(),
                                                        item.changeResult ===
                                                        "待定"
                                                          ? _c(
                                                              "play-status",
                                                              {
                                                                attrs: {
                                                                  type: "warning",
                                                                },
                                                              },
                                                              [_vm._v("待定")]
                                                            )
                                                          : _vm._e(),
                                                        item.changeResult ===
                                                        "关闭名单"
                                                          ? _c(
                                                              "play-status",
                                                              {
                                                                attrs: {
                                                                  type: "disabled",
                                                                },
                                                              },
                                                              [
                                                                _vm._v(
                                                                  "关闭名单"
                                                                ),
                                                              ]
                                                            )
                                                          : _vm._e(),
                                                        item.changeResult ===
                                                        "转线索"
                                                          ? _c(
                                                              "play-status",
                                                              {
                                                                attrs: {
                                                                  type: "green",
                                                                },
                                                              },
                                                              [_vm._v("转线索")]
                                                            )
                                                          : _vm._e(),
                                                      ],
                                                      1
                                                    ),
                                                  ]
                                                : [
                                                    item.callRecordInfo &&
                                                    item.callRecordInfo
                                                      .callStatus ===
                                                      "客户未接听"
                                                      ? _c(
                                                          "play-status",
                                                          {
                                                            attrs: {
                                                              type: "error",
                                                            },
                                                          },
                                                          [_vm._v("客户未接听")]
                                                        )
                                                      : _vm._e(),
                                                    item.callRecordInfo &&
                                                    item.callRecordInfo
                                                      .callStatus ===
                                                      "坐席未接听"
                                                      ? _c(
                                                          "play-status",
                                                          {
                                                            attrs: {
                                                              type: "error",
                                                            },
                                                          },
                                                          [_vm._v("坐席未接听")]
                                                        )
                                                      : _vm._e(),
                                                    item.callRecordInfo &&
                                                    item.callRecordInfo
                                                      .callStatus ===
                                                      "接通并回应"
                                                      ? _c(
                                                          "play-status",
                                                          {
                                                            attrs: {
                                                              type: "success",
                                                            },
                                                          },
                                                          [_vm._v("接通并回应")]
                                                        )
                                                      : _vm._e(),
                                                  ],
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                      item.callRecordInfo &&
                                      item.callRecordInfo.recordFile
                                        ? _c("audioPlay", {
                                            ref: "audioPlay",
                                            refInFor: true,
                                            attrs: {
                                              url: item.callRecordInfo
                                                .recordFile,
                                            },
                                            on: {
                                              reset2Audio: _vm.reset2Audio,
                                            },
                                          })
                                        : _vm._e(),
                                      _c(
                                        "el-row",
                                        { staticClass: "followUp_time" },
                                        [
                                          _vm.activeName === "second"
                                            ? _c(
                                                "el-col",
                                                {
                                                  staticClass: "tal",
                                                  attrs: { span: 24 },
                                                },
                                                [
                                                  _c("em", [
                                                    _vm._v("跟进情况"),
                                                  ]),
                                                  _c(
                                                    "span",
                                                    { staticClass: "max-tetx" },
                                                    [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.followResult ||
                                                            "--"
                                                        )
                                                      ),
                                                    ]
                                                  ),
                                                ]
                                              )
                                            : _vm._e(),
                                          _c(
                                            "el-col",
                                            {
                                              staticClass: "tar",
                                              attrs: { span: 24 },
                                            },
                                            [
                                              _vm.activeName === "second"
                                                ? [
                                                    _c("span", [
                                                      _vm._v("跟进时间"),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          item.createAt || "--"
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                              _vm.activeName === "third"
                                                ? [
                                                    _c("span", [
                                                      _vm._v("拨出时间"),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          (item.callRecordInfo &&
                                                            item.callRecordInfo
                                                              .createAt) ||
                                                            "--"
                                                        )
                                                      ),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v("呼叫时长"),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          (item.callRecordInfo &&
                                                            item.callRecordInfo
                                                              .totalDuration) ||
                                                            "--"
                                                        )
                                                      ),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v("通话时长"),
                                                    ]),
                                                    _c("span", [
                                                      _vm._v(
                                                        _vm._s(
                                                          (item.callRecordInfo &&
                                                            item.callRecordInfo
                                                              .bridgeDuration) ||
                                                            "--"
                                                        )
                                                      ),
                                                    ]),
                                                  ]
                                                : _vm._e(),
                                            ],
                                            2
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }),
                            _c("pagination", {
                              staticClass: "tar",
                              attrs: {
                                layout: "total, prev, pager, next, jumper",
                                pageNum: _vm.pageNum,
                                pageSize: _vm.pageSize,
                                total: _vm.total,
                              },
                              on: { currentChange: _vm.handleCurrentChange },
                            }),
                          ],
                          2
                        )
                      : _vm._e(),
                  ],
                  1
                ),
              ]
            : _vm._e(),
        ],
        2
      ),
      _c("followUpDialog", {
        ref: "followUpDialog",
        on: { getData: _vm.getData },
      }),
      _c("allotDialog", { ref: "allotDialog", on: { getData: _vm.getData } }),
      _c("activateDialog", {
        ref: "activateDialog",
        on: { getData: _vm.getData, closeDrawer: _vm.closeDrawer },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }